import React from "react";
import { Slide, Heading } from "spectacle";
import hexRgb from "hex-rgb";
import Simple2D from "../components/Simple2D";
import theme from "../theme";
import ComplexPlane from "../components/ComplexPlane";
import FunctionView from "../components/FunctionView";
import { cpow, cadd } from "../util/CMath";

const shader = `
  #define ZEROS 5
  #define ITERATIONS 40.0
	uniform vec2 zeros[ZEROS];
	uniform vec3 colors[ZEROS];
  uniform float scaling;

  float PI = 3.14159265358;
  vec4 black = vec4(0, 0, 0, 1.);
  vec4 white = vec4(1., 1., 1., 1.);

  float realToUnit(float a) {
    return 0.5+atan(2.0*length(a))/PI;
  }

  float posToUnit(float a) {
    return (realToUnit(abs(a))-0.5)*2.0;
  }

  void main(void) {
  	vec2 z = 1.1*scaling*v;
    vec2 z2 =cmul(z, z);
    vec2 z4 =cmul(z2, z2);
		vec2 f = cmul(z, z4)-vec2(1.,0.);

    float a = 1.0-posToUnit(f.x);
    float b = 1.0-posToUnit(f.y);
  	gl_FragColor = vec4(
        (a * colors[1]
        + b * colors[2]),
      1.0);
  }
`;

let complexPlane = null;
let s2dRef = null;
export default [
  <Slide>
    <Heading size={2}>
      f(z) = z<sup>5</sup> - 1
    </Heading>
    <Heading size={3}>
      <FunctionView
        animated={true}
        complex={true}
        nextPoint={() => [Math.random() * 2.2 - 1.1, Math.random() * 2.2 - 1.1]}
        precision={100}
        f={x => cadd([-1, 0], cpow(x, 5))}
      />
      <br />
      <br />
      <br />
      Hoe ziet f(z) eruit?
    </Heading>
  </Slide>,
  <Slide>
    <div
      style={{
        position: "absolute",
        height: "100%",
        width: "100%",
        top: 0,
        left: 0
      }}
    >
      <Simple2D
        shader={shader}
        libs={["cMath"]}
        locations={["zeros", "colors", "scaling"]}
        navigatable={true}
        onBeforeTick={s2d => {
          if (complexPlane) {
            s2d.gl.uniform1f(
              s2d.locations.scaling,
              window.innerHeight / complexPlane.clientHeight
            );
          }
        }}
        ref={s2d => {
          s2dRef = s2d;
          if (!s2d) return;

          s2d.gl.uniform3fv(
            s2d.locations.colors,
            Array.prototype.concat
              .apply(
                [],
                theme.screen.colors.extra
                  .map(hexRgb)
                  .map(({ red, green, blue }) => [red, green, blue])
              )
              .map(v => v / 255)
          );
          s2d.gl.uniform2fv(s2d.locations.zeros, [
            0.309016994375,
            0.951056516295,
            -0.809016994375,
            0.587785252292,
            -0.809016994375,
            -0.587785252292,
            0.309016994375,
            -0.951056516295,
            1.0,
            0.0
          ]);
        }}
      />
    </div>
    <div
      style={{ zIndex: 10, position: "relative" }}
      ref={c => {
        complexPlane = c;
        if (s2dRef) s2dRef.invalidate();
      }}
    >
      <ComplexPlane xMax={(1.1 * 12) / 8.5} />
    </div>
  </Slide>
];
